export interface FAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
}

export const faqData: FAQ[] = [
  {
    id: 1,
    question: "What types of tours do you offer?",
    answer:
      "We offer a wide range of tours including Self Drive, Guided and Motorhome packages, covering North Island and South Island. Each package can be customised to match your interests, needs and wishlists.",
    category: "Tours",
  },
  {
    id: 2,
    question: "How do I book a tour?",
    answer:
      "Booking is easy! You can browse our tour packages on the website, select your preferred dates, and book online. Alternatively, you can contact us via WhatsApp at +64221841601 or email us at info@ikhlastours.co.nz for personalized assistance with your booking.",
    category: "Booking",
  },
  {
    id: 3,
    question: "What is included in the tour packages?",
    answer:
      "Our tour packages typically include transportation, accommodation, guided tours, and selected meals. Specific inclusions vary by package, so please check the detailed itinerary for each tour. We can also customize packages to include or exclude specific services based on your preferences.",
    category: "Tours",
  },
  {
    id: 4,
    question: "Do you offer vehicle rentals?",
    answer:
      "Yes, we offer a variety of rental vehicles including cars, campervans, and motorhomes. All our vehicles are well maintained and come with comprehensive insurance. We can provide vehicle rentals as part of a tour package or as a standalone service.",
    category: "Vehicles",
  },
  {
    id: 5,
    question: "What is your cancellation policy?",
    answer:
      "We offer flexible cancellation terms. Cancellations made 30 days or more before departure receive a full refund. Cancellations 15-29 days before receive a 50% refund, and cancellations less than 15 days before are non-refundable. We recommend travel insurance for additional protection.",
    category: "Booking",
  },
  {
    id: 6,
    question: "Are your tours suitable for families with children?",
    answer:
      "Absolutely! Many of our tours are family friendly and can be adapted for travelers of all ages. We can provide child seats for vehicles, suggest family friendly accommodations, and adjust activity levels to suit children. Please let us know about children in your group when booking.",
    category: "General",
  },
  {
    id: 7,
    question: "What activities can I book through your service?",
    answer:
      "We offer a diverse range of activities including bungy jumping, hiking, glacier walks, wildlife tours, Maori cultural experiences, and scenic flights. We partner with trusted activity providers across New Zealand to ensure high quality experiences at competitive prices.",
    category: "Activities",
  },
  {
    id: 8,
    question: "Do you provide airport transfers?",
    answer:
      "Yes, we provide airport transfers from all major New Zealand airports including Auckland, Wellington, Christchurch, and Queenstown. Transfers can be arranged as part of your tour package or as a standalone service.",
    category: "General",
  },
  {
    id: 9,
    question: "What payment methods do you accept?",
    answer:
      "We accept various payment methods including credit/debit cards (Visa, Mastercard), bank transfers, and PayPal. A 20% deposit is required to confirm your booking, with the remaining balance due 30 days before your tour departure.",
    category: "Booking",
  },
  {
    id: 10,
    question: "Can you customize tours for special occasions?",
    answer:
      "Yes, we specialize in creating customized tours for special occasions including honeymoons, anniversaries, family reunions, and corporate events. Our team can help design a unique itinerary that matches your specific requirements and preferences.",
    category: "Tours",
  },
  {
    id: 11,
    question: "What should I pack for my New Zealand trip?",
    answer:
      "New Zealand's weather can be unpredictable, so we recommend packing layers. Bring waterproof clothing, comfortable walking shoes, sun protection, and insect repellent. For specific activities, you may need specialized gear which we can provide or help you rent. We'll send you a detailed packing list based on your specific itinerary.",
    category: "General",
  },
  {
    id: 12,
    question: "Do you offer travel insurance?",
    answer:
      "While we don't directly provide travel insurance, we strongly recommend all our clients purchase comprehensive travel insurance. We can recommend trusted insurance providers and help ensure your coverage meets New Zealand's requirements and your specific needs.",
    category: "Booking",
  },
];
